import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { NotFound } from './pages/not-found/not-found';
import { GamesListComponent } from './pages/games/games-list/games-list';
import { authGuard } from './core/guards/auth.guard';
import { configResolver } from './core/resolvers/config-resolver';
import { CreateGame } from './pages/games/create-game/create-game';
import { WaitingGame } from './pages/games/waiting/waiting-game/waiting-game';
import { gameResolver } from './core/resolvers/game-resolver';
import { playersResolver } from './core/resolvers/players-resolver';
import { GameItself } from './pages/games/game-itself/game-itself';
import { StepOne } from './pages/steps/step-one/step-one';
import { StepTwo } from './pages/steps/step-two/step-two';
import { StepThree } from './pages/steps/step-three/step-three';
import { Lobby } from './pages/games/lobby/lobby';
import { GuestLayout } from './layout/guest-layout/guest-layout';
import { AuthLayout } from './layout/auth-layout/auth-layout';
import { GameCoOp } from './pages/games/game-co-op/game-co-op';

export const routes: Routes = [
    {
        path: '',
        component: GuestLayout,
        children: [
            {
                path: '',
                component: Home,
                title: 'Nutrimind Game - home'
            }
        ]
    },
    {
        path: '',
        component: AuthLayout,
        canActivate: [authGuard],
        children: [
            {
                path: 'step-one',
                component: StepOne,
                canActivate: [authGuard],
                title: 'Nutrimind Game - create game'        
            },
            {
                path: 'step-two',
                component: StepTwo,
                canActivate: [authGuard],
                title: 'Nutrimind Game - create game'        
            },
            {
                path: 'step-three',
                component: StepThree,
                canActivate: [authGuard],
                title: 'Nutrimind Game - create game'        
            },
            {
                path: 'games',
                component: GamesListComponent,
                canActivate: [authGuard],
                title: 'Nutrimind Game - list games'        
            },
            {
                path: 'create-game',
                component: CreateGame,
                canActivate: [authGuard],
                title: 'Nutrimind Game - create game'        
            },
            {
                path: 'waiting/:id',
                component: WaitingGame,
                canActivate: [authGuard],
                resolve:{
                    room: gameResolver,
                    players: playersResolver
                },
                title: 'Nutrimind Game - waiting game'        
            },
            {
                path: 'lobby/:id',
                component: Lobby,
                canActivate: [authGuard],
                resolve:{
                    room: gameResolver,
                    players: playersResolver
                },
                title: 'Nutrimind Game - lobby game'        
            }
        ]
    },
    {
        path: 'single-game/:id',
        component: GameItself,
        canActivate: [authGuard],
        resolve:{
            room: gameResolver,
            players: playersResolver
        },
        title: 'Nutrimind Game - the game itself'
    },
    {
        path: 'coop-game/:id',
        component: GameCoOp,
        canActivate: [authGuard],
        resolve:{
            room: gameResolver,
            players: playersResolver
        },
        title: 'Nutrimind Game - the game itself'
    },
    {
        path: '**',
        redirectTo: '',
        component: NotFound,
        title: 'Nutrimind Game - page not found'
    }
];
